export const ChevronLeft = ({ width, height }: { width?: number; height?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none">
    <path
      d="M14.4697 5.46973C14.7626 5.17683 15.2374 5.17683 15.5303 5.46973C15.8232 5.76262 15.8232 6.23738 15.5303 6.53027L10.0605 12L15.5303 17.4697C15.8232 17.7626 15.8232 18.2374 15.5303 18.5303C15.2374 18.8232 14.7626 18.8232 14.4697 18.5303L8.46973 12.5303C8.17683 12.2374 8.17683 11.7626 8.46973 11.4697L14.4697 5.46973Z"
      fill="currentColor"
    />
  </svg>
);
export const ChevronRight = ({ width, height }: { width?: number; height?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none">
    <path
      d="M8.46973 5.46973C8.76262 5.17683 9.23738 5.17683 9.53027 5.46973L15.5303 11.4697C15.8232 11.7626 15.8232 12.2374 15.5303 12.5303L9.53027 18.5303C9.23738 18.8232 8.76262 18.8232 8.46973 18.5303C8.17683 18.2374 8.17683 17.7626 8.46973 17.4697L13.9395 12L8.46973 6.53027C8.17683 6.23738 8.17683 5.76262 8.46973 5.46973Z"
      fill="currentColor"
    />
  </svg>
);
export const ChevronDown = ({ width, height }: { width?: number; height?: number }) => (
  <svg width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4697 8.46973C17.7626 8.17683 18.2374 8.17683 18.5303 8.46973C18.8232 8.76262 18.8232 9.23738 18.5303 9.53027L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303L5.46973 9.53027C5.17683 9.23738 5.17683 8.76262 5.46973 8.46973C5.76262 8.17683 6.23738 8.17683 6.53027 8.46973L12 13.9395L17.4697 8.46973Z"
      fill="currentColor"
    />
  </svg>
);
export const ChevronUp = ({ width, height }: { width?: number; height?: number }) => (
  <svg width={width || '22'} height={height || '22'} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5264 7.66797C10.821 7.42775 11.2558 7.44518 11.5303 7.71973L17.0303 13.2197C17.3232 13.5126 17.3231 13.9874 17.0303 14.2803C16.7374 14.5732 16.2627 14.5732 15.9698 14.2803L11.0001 9.31055L6.03033 14.2803C5.73744 14.5732 5.26268 14.5732 4.96979 14.2803C4.67692 13.9874 4.6769 13.5126 4.96979 13.2197L10.4698 7.71973L10.5264 7.66797Z"
      fill="currentColor"
    />
  </svg>
);
export const Close = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.2197 0.219727C12.5126 -0.0731666 12.9874 -0.0731664 13.2803 0.219727C13.5732 0.51262 13.5732 0.98738 13.2803 1.28027L7.81055 6.75L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L6.75 7.81055L1.28027 13.2803C0.98738 13.5732 0.51262 13.5732 0.219727 13.2803C-0.0731664 12.9874 -0.0731666 12.5126 0.219727 12.2197L5.68945 6.75L0.219727 1.28027C-0.0731664 0.98738 -0.0731666 0.51262 0.219727 0.219727C0.51262 -0.0731666 0.98738 -0.0731664 1.28027 0.219727L6.75 5.68945L12.2197 0.219727Z"
      fill="currentColor"
    />
  </svg>
);
export const Logout = () => (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.75 0C10.4793 0 11.1786 0.289939 11.6943 0.805664C12.2101 1.32139 12.5 2.02065 12.5 2.75V4.75C12.5 5.16421 12.1642 5.5 11.75 5.5C11.3358 5.5 11 5.16421 11 4.75V2.75C11 2.41848 10.8682 2.10063 10.6338 1.86621C10.4288 1.6612 10.16 1.53436 9.87402 1.50586L9.75 1.5H2.75C2.41848 1.5 2.10063 1.63179 1.86621 1.86621C1.63179 2.10063 1.5 2.41848 1.5 2.75V14.75C1.5 15.0815 1.63179 15.3994 1.86621 15.6338C2.10063 15.8682 2.41848 16 2.75 16H9.75C10.0815 16 10.3994 15.8682 10.6338 15.6338C10.8682 15.3994 11 15.0815 11 14.75V12.75C11 12.3358 11.3358 12 11.75 12C12.1642 12 12.5 12.3358 12.5 12.75V14.75C12.5 15.4793 12.2101 16.1786 11.6943 16.6943C11.1786 17.2101 10.4793 17.5 9.75 17.5H2.75C2.02065 17.5 1.32139 17.2101 0.805664 16.6943C0.289939 16.1786 0 15.4793 0 14.75V2.75C0 2.02065 0.289939 1.32139 0.805664 0.805664C1.32139 0.289939 2.02065 0 2.75 0H9.75ZM15.2197 5.21973C15.5126 4.92683 15.9874 4.92683 16.2803 5.21973L19.2803 8.21973C19.5732 8.51262 19.5732 8.98738 19.2803 9.28027L16.2803 12.2803C15.9874 12.5732 15.5126 12.5732 15.2197 12.2803C14.9268 11.9874 14.9268 11.5126 15.2197 11.2197L16.9395 9.5H4.75C4.33579 9.5 4 9.16421 4 8.75C4 8.33579 4.33579 8 4.75 8H16.9395L15.2197 6.28027C14.9268 5.98738 14.9268 5.51262 15.2197 5.21973Z"
      fill="currentColor"
    />
  </svg>
);
export const SearchIco = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 11.87 17.0872 13.585 15.9844 14.9238L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L14.9238 15.9844C13.585 17.0872 11.87 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10C2.25 5.71979 5.71979 2.25 10 2.25ZM10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25C13.4518 16.25 16.25 13.4518 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75Z"
      fill="currentColor"
    />
  </svg>
);
export const SelectIco = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 14L4.5 10.5L5.205 9.795L8 12.585L10.795 9.795L11.5 10.5L8 14ZM8 2L11.5 5.5L10.795 6.205L8 3.415L5.205 6.205L4.5 5.5L8 2Z"
      fill="currentColor"
    />
  </svg>
);
export const CircleCheckBoldIco = ({ width, height }: { width?: number; height?: number }) => (
  <svg width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      fill="#334155"
      stroke="#334155"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 12L11 15L16.5 9.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const FilterIco = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 5C0 4.44772 0.447715 4 1 4H19C19.5523 4 20 4.44772 20 5C20 5.55228 19.5523 6 19 6H1C0.447716 6 0 5.55228 0 5Z"
      fill="currentColor"
    />
    <path
      d="M3 10C3 9.44772 3.44772 9 4 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H4C3.44772 11 3 10.5523 3 10Z"
      fill="currentColor"
    />
    <path
      d="M8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H12C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14H8Z"
      fill="currentColor"
    />
  </svg>
);
export const DownloadIco = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_84_2837)">
      <path
        d="M15.5555 20H4.44443C3.25736 20 2.14127 19.5377 1.30177 18.6982C0.462309 17.8588 0 16.7427 0 15.5555V14.4444C0 13.8307 0.497435 13.3332 1.11112 13.3332C1.7248 13.3332 2.22224 13.8307 2.22224 14.4444V15.5555C2.22224 16.1491 2.45341 16.7071 2.87306 17.1268C3.29283 17.5466 3.85085 17.7778 4.44443 17.7778H15.5555C16.1491 17.7778 16.7071 17.5466 17.1268 17.1268C17.5466 16.7071 17.7778 16.149 17.7778 15.5555V14.4444C17.7778 13.8307 18.2752 13.3332 18.8888 13.3332C19.5025 13.3332 20 13.8307 20 14.4444V15.5555C20 16.7426 19.5377 17.8587 18.6982 18.6982C17.8587 19.5377 16.7426 20 15.5555 20ZM9.99998 15.5555C9.84628 15.5555 9.69995 15.5243 9.56682 15.4679C9.44262 15.4154 9.3259 15.3392 9.22379 15.2395C9.22375 15.2394 9.22375 15.2394 9.22371 15.2394C9.22297 15.2387 9.22223 15.238 9.2215 15.2372C9.2213 15.2371 9.22107 15.2368 9.22087 15.2366C9.22025 15.2361 9.21971 15.2355 9.21913 15.2349C9.21874 15.2345 9.21839 15.2342 9.218 15.2338C9.21761 15.2334 9.21711 15.2329 9.21676 15.2326C9.21598 15.2318 9.21513 15.2309 9.21435 15.2302L4.76988 10.7856C4.33599 10.3517 4.33599 9.64821 4.76988 9.21428C5.20378 8.78038 5.90736 8.78034 6.34125 9.21428L8.8889 11.7619V1.11112C8.88886 0.497435 9.3863 0 9.99998 0C10.6137 0 11.1111 0.497435 11.1111 1.11112V11.7619L13.6587 9.21428C14.0926 8.78038 14.7963 8.78038 15.2301 9.21428C15.664 9.64817 15.664 10.3517 15.2301 10.7856L10.7856 15.2301C10.7849 15.2309 10.784 15.2317 10.7832 15.2325C10.7828 15.2329 10.7823 15.2334 10.782 15.2337C10.7816 15.2341 10.7813 15.2344 10.7809 15.2348C10.7803 15.2354 10.7797 15.236 10.7792 15.2365C10.779 15.2367 10.7787 15.237 10.7785 15.2371C10.7778 15.2379 10.7771 15.2386 10.7763 15.2393C10.7763 15.2393 10.7763 15.2394 10.7763 15.2394C10.764 15.2513 10.7516 15.2629 10.739 15.2741C10.646 15.3571 10.5423 15.4218 10.4328 15.468C10.4324 15.4682 10.4321 15.4683 10.4317 15.4685C10.4312 15.4686 10.4309 15.4689 10.4305 15.469C10.298 15.5247 10.1526 15.5555 9.99998 15.5555Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_84_2837">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const GitLineIco = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 2.75V13.75M5.5 13.75C3.98122 13.75 2.75 14.9812 2.75 16.5C2.75 18.0188 3.98122 19.25 5.5 19.25C7.01878 19.25 8.25 18.0188 8.25 16.5M5.5 13.75C7.01878 13.75 8.25 14.9812 8.25 16.5M16.5 8.25C18.0188 8.25 19.25 7.01878 19.25 5.5C19.25 3.98122 18.0188 2.75 16.5 2.75C14.9812 2.75 13.75 3.98122 13.75 5.5C13.75 7.01878 14.9812 8.25 16.5 8.25ZM16.5 8.25C16.5 10.438 15.6308 12.5365 14.0836 14.0836C12.5365 15.6308 10.438 16.5 8.25 16.5"
      stroke="#1E1E1E"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TableIco = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.4998 3.6665H5.49984C4.48732 3.6665 3.6665 4.48732 3.6665 5.49984V16.4998C3.6665 17.5124 4.48732 18.3332 5.49984 18.3332H16.4998C17.5124 18.3332 18.3332 17.5124 18.3332 16.4998V5.49984C18.3332 4.48732 17.5124 3.6665 16.4998 3.6665Z"
      stroke="#334155"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.6665 9.1665H18.3332"
      stroke="#334155"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.1665 3.6665V18.3332"
      stroke="#334155"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const GuideIco = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 18C16.6569 18 18 16.6569 18 15C18 13.3431 16.6569 12 15 12C13.3431 12 12 13.3431 12 15C12 16.6569 13.3431 18 15 18Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 17.5V22L15 20.5L17 22V17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7C3 5.9 3.9 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V17C20.9996 17.3507 20.9071 17.6952 20.7315 17.9988C20.556 18.3025 20.3037 18.5546 20 18.73"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6 9H18" stroke="#334155" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 12H9" stroke="#334155" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 15H8" stroke="#334155" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const MailIco = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.0001 5H5.00008C3.89551 5 3.00008 5.89543 3.00008 7V17C3.00008 18.1046 3.89551 19 5.00008 19H19.0001C20.1047 19 21.0001 18.1046 21.0001 17V7C21.0001 5.89543 20.1047 5 19.0001 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.00008 7L12.0001 13L21.0001 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CalendarOutlinedIco = () => (
  <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 2V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 2V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 10H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const RocketIco = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 21C7.10457 21 8 20.1046 8 19C8 17.8954 7.10457 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 7C19.1046 7 20 6.10457 20 5C20 3.89543 19.1046 3 18 3C16.8954 3 16 3.89543 16 5C16 6.10457 16.8954 7 18 7Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 19H16.5C17.4283 19 18.3185 18.6313 18.9749 17.9749C19.6313 17.3185 20 16.4283 20 15.5C20 14.5717 19.6313 13.6815 18.9749 13.0251C18.3185 12.3687 17.4283 12 16.5 12H8.5C7.57174 12 6.6815 11.6313 6.02513 10.9749C5.36875 10.3185 5 9.42826 5 8.5C5 7.57174 5.36875 6.6815 6.02513 6.02513C6.6815 5.36875 7.57174 5 8.5 5H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/** Robot — menu AI Coaching (cùng nét 1.5 / 24px với icon menu khác). */
export const RobotIco = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17 6H7C5.89543 6 5 6.89543 5 8V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V8C19 6.89543 18.1046 6 17 6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.5 11.5V12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 11.5V12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.5 15.5H14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 11V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 11V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const Setting2Ico = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.325 4.317C10.751 2.561 13.249 2.561 13.675 4.317C13.7389 4.5808 13.8642 4.82578 14.0407 5.032C14.2172 5.23822 14.4399 5.39985 14.6907 5.50375C14.9414 5.60764 15.2132 5.65085 15.4838 5.62987C15.7544 5.60889 16.0162 5.5243 16.248 5.383C17.791 4.443 19.558 6.209 18.618 7.753C18.4769 7.98466 18.3924 8.24634 18.3715 8.51677C18.3506 8.78721 18.3938 9.05877 18.4975 9.30938C18.6013 9.55999 18.7627 9.78258 18.9687 9.95905C19.1747 10.1355 19.4194 10.2609 19.683 10.325C21.439 10.751 21.439 13.249 19.683 13.675C19.4192 13.7389 19.1742 13.8642 18.968 14.0407C18.7618 14.2172 18.6001 14.4399 18.4963 14.6907C18.3924 14.9414 18.3491 15.2132 18.3701 15.4838C18.3911 15.7544 18.4757 16.0162 18.617 16.248C19.557 17.791 17.791 19.558 16.247 18.618C16.0153 18.4769 15.7537 18.3924 15.4832 18.3715C15.2128 18.3506 14.9412 18.3938 14.6906 18.4975C14.44 18.6013 14.2174 18.7627 14.0409 18.9687C13.8645 19.1747 13.7391 19.4194 13.675 19.683C13.249 21.439 10.751 21.439 10.325 19.683C10.2611 19.4192 10.1358 19.1742 9.95929 18.968C9.7828 18.7618 9.56011 18.6001 9.30935 18.4963C9.05859 18.3924 8.78683 18.3491 8.51621 18.3701C8.24559 18.3911 7.98375 18.4757 7.752 18.617C6.209 19.557 4.442 17.791 5.382 16.247C5.5231 16.0153 5.60755 15.7537 5.62848 15.4832C5.64942 15.2128 5.60624 14.9412 5.50247 14.6906C5.3987 14.44 5.23726 14.2174 5.03127 14.0409C4.82529 13.8645 4.58056 13.7391 4.317 13.675C2.561 13.249 2.561 10.751 4.317 10.325C4.5808 10.2611 4.82578 10.1358 5.032 9.95929C5.23822 9.7828 5.39985 9.56011 5.50375 9.30935C5.60764 9.05859 5.65085 8.78683 5.62987 8.51621C5.60889 8.24559 5.5243 7.98375 5.383 7.752C4.443 6.209 6.209 4.442 7.753 5.382C8.753 5.99 10.049 5.452 10.325 4.317Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ListLibIco = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 17.25C5.41421 17.25 5.75 17.5858 5.75 18V18.0098C5.75 18.424 5.41421 18.7598 5 18.7598C4.58579 18.7598 4.25 18.424 4.25 18.0098V18C4.25 17.5858 4.58579 17.25 5 17.25ZM20 17.25C20.4142 17.25 20.75 17.5858 20.75 18C20.75 18.4142 20.4142 18.75 20 18.75H9C8.58579 18.75 8.25 18.4142 8.25 18C8.25 17.5858 8.58579 17.25 9 17.25H20ZM5 11.25C5.41421 11.25 5.75 11.5858 5.75 12V12.0098C5.75 12.424 5.41421 12.7598 5 12.7598C4.58579 12.7598 4.25 12.424 4.25 12.0098V12C4.25 11.5858 4.58579 11.25 5 11.25ZM20 11.25C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H9C8.58579 12.75 8.25 12.4142 8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H20ZM5 5.25C5.41421 5.25 5.75 5.58579 5.75 6V6.00977C5.75 6.42398 5.41421 6.75977 5 6.75977C4.58579 6.75977 4.25 6.42398 4.25 6.00977V6C4.25 5.58579 4.58579 5.25 5 5.25ZM20 5.25C20.4142 5.25 20.75 5.58579 20.75 6C20.75 6.41421 20.4142 6.75 20 6.75H9C8.58579 6.75 8.25 6.41421 8.25 6C8.25 5.58579 8.58579 5.25 9 5.25H20Z"
      fill="currentColor"
    />
  </svg>
);
export const TipIco = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      fill="white"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 17V17.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12 13.5C11.9816 13.1754 12.0692 12.8535 12.2495 12.583C12.4299 12.3125 12.6933 12.1078 13 12C13.3759 11.8562 13.7132 11.6272 13.9856 11.3309C14.2579 11.0347 14.4577 10.6792 14.5693 10.2926C14.6809 9.90594 14.7013 9.49868 14.6287 9.10285C14.5562 8.70702 14.3928 8.33343 14.1513 8.0115C13.9099 7.68956 13.597 7.42807 13.2373 7.2476C12.8776 7.06713 12.4809 6.97262 12.0785 6.97151C11.6761 6.97039 11.2789 7.0627 10.9182 7.24117C10.5576 7.41964 10.2432 7.67939 10 7.99998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RefeshIco = ({ width, height }: { width?: number; height?: number }) => (
  <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.89746 12.257C4.30743 12.2003 4.68704 12.4867 4.74414 12.8966C4.9661 14.4934 5.70706 15.9732 6.85254 17.1076C7.99795 18.2416 9.48442 18.9686 11.083 19.175C12.6817 19.3811 14.3044 19.0555 15.7002 18.2492C16.7567 17.6388 17.639 16.7777 18.2744 15.7502H16.001C15.5868 15.7502 15.2511 15.4143 15.251 15.0002C15.251 14.5859 15.5868 14.2502 16.001 14.2502H20.001C20.4149 14.2505 20.751 14.5862 20.751 15.0002V19.0002C20.7509 19.4141 20.4149 19.7498 20.001 19.7502C19.5868 19.7502 19.2511 19.4143 19.251 19.0002V16.9894C18.5174 18.0281 17.5653 18.9042 16.4512 19.548C14.7706 20.5189 12.8166 20.9105 10.8916 20.6623C8.9667 20.4139 7.1761 19.5395 5.79688 18.174C4.41767 16.8082 3.5251 15.0262 3.25781 13.1037C3.20081 12.6935 3.48731 12.3141 3.89746 12.257ZM7.55078 4.45133C9.23147 3.48052 11.1854 3.08971 13.1104 3.33805C15.0353 3.58656 16.8259 4.46066 18.2051 5.82633C19.5842 7.19217 20.4769 8.97411 20.7441 10.8966C20.801 11.3065 20.5142 11.6849 20.1045 11.7423C19.6943 11.7994 19.3149 11.5129 19.2578 11.1027C19.0358 9.50622 18.2947 8.02697 17.1494 6.89274C16.0041 5.75854 14.5175 5.03182 12.9189 4.82536C11.3204 4.61909 9.69752 4.9441 8.30176 5.75016C7.24499 6.36067 6.36206 7.22231 5.72656 8.25016H8.00098C8.41483 8.25049 8.75085 8.58626 8.75098 9.00016C8.75073 9.41396 8.41476 9.74983 8.00098 9.75016H4.00098C3.58691 9.75016 3.25122 9.41417 3.25098 9.00016V5.00016C3.25111 4.58606 3.58684 4.25016 4.00098 4.25016C4.41483 4.25049 4.75085 4.58626 4.75098 5.00016V7.00993C5.48462 5.97143 6.43661 5.095 7.55078 4.45133Z"
      fill="currentColor"
    />
  </svg>
);
export const ReloadIco = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1149_5287)">
      <path
        d="M19.9331 13.0409C19.7442 14.4809 19.167 15.8422 18.2632 16.9791C17.3595 18.1159 16.1633 18.9853 14.803 19.4939C13.4427 20.0026 11.9696 20.1314 10.5417 19.8665C9.1138 19.6016 7.78492 18.953 6.69761 17.9902C5.6103 17.0275 4.80557 15.7869 4.36973 14.4015C3.93389 13.0162 3.88338 11.5384 4.22362 10.1265C4.56385 8.71462 5.282 7.422 6.30104 6.38726C7.32007 5.35251 8.60156 4.61468 10.0081 4.2529C13.9071 3.2509 17.9431 5.2599 19.4331 8.9999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M20 4V9H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1149_5287">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const RetweetIco = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 5V16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 13.5L7 17.5L10 13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 19V8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 10.5L17 6.5L20 10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
